
<div id='container' #iconContainer [ngClass]='classes()' kendoTooltip showOn='none'  (click)='onClick($event)'>
	<i #anchor [ngClass]='iconClasses()' [title]="tooltip"></i>
	<label *ngIf='showCaption()' [ngClass]='captionClasses()' >
		{{this.icon.caption.text}}
	</label>
</div>
